<div class="loading" [hidden]="!show_loading">
  <div class="loader">Loading...</div>
</div>
<div class="modal-header">
  <button
    type="button"
    class="btn-close"
    (click)="bsModalRef.hide()"
    aria-label="Close"
  >
    <i class="feather x"></i>
  </button>
  <h3 class="modal-title" id="myModalLabel">Notification Settings</h3>
</div>

<div class="modal-body">
  <div
    class="card-modal"
    style="
      background: #fff;
      padding: 15px;
      border-radius: 12px;
      margin-bottom: 16px;
    "
  >
    <h2>Where to Get Notified</h2>

    <h3 style="margin-top: 0">In-App and Email Notifications</h3>
    <p>
      We automatically post notifications to the “bell icon”
      <svg
        width="16"
        height="16"
        viewBox="0 0 16 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M6.10334 14.0905C6.10331 14.0946 6.10303 14.0988 6.10303 14.103C6.10303 15.1507 6.95236 16 8.00007 16C9.04778 16 9.89711 15.1507 9.89711 14.103C9.89711 14.0988 9.89683 14.0946 9.8968 14.0905H6.10334Z"
          fill="#485364"
        />
        <path
          d="M14.0569 11.7192L12.3495 9.21111C12.3495 8.44335 12.3495 6.56735 12.3495 6.08206C12.3495 3.97184 10.8467 2.21284 8.85295 1.81644V0.852887C8.85292 0.381875 8.47108 0 8.00003 0C7.52898 0 7.14714 0.381875 7.14714 0.852887V1.81647C5.15341 2.21291 3.65057 3.97191 3.65057 6.08209C3.65057 6.90819 3.65057 8.73233 3.65057 9.21115L1.94323 11.7192C1.76338 11.9834 1.74436 12.3253 1.8938 12.6078C2.04323 12.8903 2.3366 13.067 2.65619 13.067H13.3439C13.6635 13.067 13.9568 12.8903 14.1063 12.6078C14.2557 12.3253 14.2367 11.9833 14.0569 11.7192Z"
          fill="#485364"
        />
      </svg>
      in Client Hub. We also push unread notifications to email.
    </p>

    <!-- <hr>
  
    <h3 style="margin-top: 0">Browser Web Push Notifications</h3>
    <a (click)="toggleWebPushNotifications()">
      <button class="btn btn-primary">
        <span *ngIf="!has_web_push_enabled"
          >Subscribe</span
        >
        <span *ngIf="has_web_push_enabled"
          >Unsubscribe</span
        >
      </button>
    </a> -->

    <hr />

    <h3 style="margin-top: 0">Mobile Notifications</h3>
    <p>
      Download our mobile app on your iOS or Android device to enable mobile
      push notifications.
    </p>
    <img class="img-responsive" style="max-width: 100%;" src="assets/img/app-ad-4.png" />
  </div>

  <div
    class="card-modal"
    style="background: #fff; padding: 15px; border-radius: 12px"
    *ngIf="data.user_type == 1"
  >
    <h2 style="margin-top: 0">What to Get Notified on</h2>

    <h3 style="margin-top: 0">Internal Workspace activity</h3>
    <p>
      We always notify you on when a job (or job comment) is assigned to you.
    </p>

    <h3>Client Communication activity</h3>
    <p>
      You can choose which client workspaces to “Follow” below. If you do not
      need notifications about ongoing client actions in a workspace, you can
      choose to Not Follow.
    </p>

    <h4 style="margin-top: 30px">Choose Workspaces to Follow</h4>
    <div>
      <table
        class="table table-borderless table-striped highlight-columns table-assigments border-mobile table-notifications"
      >
        <thead class="default">
          <tr>
            <th>Workspace Name</th>
            <th class="text-center">Follow?</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let workspace of workspaces">
            <th class="ellipsis-th" title="{{ workspace.name }}">
              {{ workspace.name }}
            </th>
            <td class="text-center notifications-check">
              <label>
                <input
                  style="margin: 0"
                  type="checkbox"
                  [checked]="
                    isFollowingWorkspace(workspace.company_conversation?.uuid)
                  "
                  (change)="
                    toggleConversationNotifications(
                      workspace.company_conversation?.uuid
                    )
                  "
                />
                <i class="feather check"></i>
              </label>
            </td>
          </tr>
        </tbody>
      </table>

      <div class="load-more-wrapper">
        <button
          class="btn btn-primary-light"
          *ngIf="loaded_count < workspaces_count"
          (click)="getWorkspacesPaginated(loaded_count)"
        >
          Load More
        </button>
      </div>

      <h4 style="margin-top: 45px">Follow New Workspaces</h4>
      <p>
        Choose behavior for when you haven’t set a follow status (such as when a
        new workspace is created)
      </p>

      <div class="radio" style="margin-left: 20px">
        <label>
          <input
            type="radio"
            id="auto_follow_true"
            value="true"
            name="auto_follow"
            [checked]="defaultFollowBehavior"
            (change)="toggleDefaultConversationNotifications()"
          />
          Follow
        </label>
      </div>

      <div class="radio" style="margin-left: 20px">
        <label>
          <input
            type="radio"
            id="auto_follow_false"
            value="false"
            name="auto_follow"
            [checked]="!defaultFollowBehavior"
            (change)="toggleDefaultConversationNotifications()"
          />
          Don't follow
        </label>
      </div>
    </div>
  </div>

  <!-- <hr>

      <div class="client-events-notifications">
        <h3>Follow client-related event notifications</h3>
      <p>Client Task notifications, Client Shared folder notifications</p>

      <div class="client-events-radios">
        <div class="radio">
          <label>
            <input type="radio" name="" id="" value="">
            Follow these in all workspaces
          </label>
        </div>
        <div class="radio">
          <label>
            <input type="radio" name="" id="" value="">
            Do Not Follow these in any workspace 
          </label>
        </div>
        <div class="radio">
          <label>
            <input type="radio" name="" id="" value="">
            Control which workspace I follow these in
          </label>
        </div>
      </div>

      <table class="table table-borderless table-striped">
        <thead>
          <tr>
            <th>Workspace</th>
            <th class="text-center">Client Hub notifications</th>
            <th class="text-center">Email notifications</th>
          </tr>
        </thead>
          <tbody>
            <tr>
              <td>Wayne Enterprises</td>
              <td class="text-center">
                <input type="checkbox" name="" id="">
              </td>
              <td class="text-center">
                <input type="checkbox" name="" id="">
              </td>
            </tr>
            <tr>
              <td>Wayne Enterprises</td>
              <td class="text-center">
                <input type="checkbox" name="" id="">
              </td>
              <td class="text-center">
                <input type="checkbox" name="" id="">
              </td>
            </tr>
          </tbody>
        </table>
      </div> -->
</div>
